module.exports = __webpack_public_path__ + "static/media/hike.e5341e03.png";